// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.weather-alerts-container {
  margin-bottom: 15px;
  width: 100%;
}

/* Alert banner styling to match the red warning banner in the screenshot */
.weather-alert {
  background-color: #ffffff;
  border-radius: 4px;
  margin-bottom: 5px;
  overflow: hidden;
  transition: box-shadow 0.3s ease;
}

.weather-alert:first-child {
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.weather-alert:last-child {
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  margin-bottom: 0;
}

.weather-alert .alert-header {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  cursor: pointer;
  position: relative;
}

.weather-alert:first-child .alert-header {
  background-color: #c41e3a;
  color: white;
}

.weather-alert:first-child .alert-headline {
  color: white;
  font-weight: 700;
}

.weather-alert .alert-icon {
  margin-right: 12px;
  font-size: 20px;
  flex-shrink: 0;
}

.weather-alert .alert-headline {
  flex-grow: 1;
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.weather-alert .alert-toggle {
  margin-left: 8px;
  font-size: 12px;
  color: inherit;
  opacity: 0.7;
}

.weather-alert .alert-details {
  padding: 0 16px 16px;
  background-color: #f8f9fa;
  font-size: 14px;
  line-height: 1.5;
  border-top: 1px solid #eee;
}

.weather-alert .alert-meta {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  font-size: 13px;
  color: #666;
}

.weather-alert .alert-instructions h4,
.weather-alert .alert-description h4 {
  margin: 0 0 8px;
  font-size: 14px;
  font-weight: 600;
}

.weather-alert .alert-instructions p,
.weather-alert .alert-description p {
  margin: 0 0 16px;
  white-space: pre-line;
}

.weather-alert .alert-timing {
  font-size: 12px;
  color: #666;
  padding-top: 12px;
  border-top: 1px solid #eee;
}

.weather-alert .alert-timing p {
  margin: 4px 0;
}

/* Animation for expanded alert */
.weather-alert.expanded {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

/* Winter storm watch specific styling to match screenshot */
.weather-alert[data-alert-type="winter-storm-watch"] .alert-header {
  background-color: #c41e3a;
  color: white;
}

/* Special styling for different severity levels */
.weather-alert.extreme {
  background-color: rgba(217, 43, 43, 0.05);
}

.weather-alert.severe {
  background-color: rgba(255, 92, 51, 0.05);
}

.weather-alert.moderate {
  background-color: rgba(255, 166, 77, 0.05);
}

/* Animation for the toggle */
.alert-toggle {
  transition: transform 0.3s ease;
}

.weather-alert.expanded .alert-toggle {
  transform: rotate(180deg);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .alert-meta {
    flex-direction: column;
  }
  
  .alert-severity {
    margin-bottom: 4px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/WeatherAlerts.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,2EAA2E;AAC3E;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,WAAW;AACb;;AAEA;;EAEE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,wCAAwC;AAC1C;;AAEA,4DAA4D;AAC5D;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,kDAAkD;AAClD;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,6BAA6B;AAC7B;EACE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".weather-alerts-container {\n  margin-bottom: 15px;\n  width: 100%;\n}\n\n/* Alert banner styling to match the red warning banner in the screenshot */\n.weather-alert {\n  background-color: #ffffff;\n  border-radius: 4px;\n  margin-bottom: 5px;\n  overflow: hidden;\n  transition: box-shadow 0.3s ease;\n}\n\n.weather-alert:first-child {\n  border-top-left-radius: 8px;\n  border-top-right-radius: 8px;\n}\n\n.weather-alert:last-child {\n  border-bottom-left-radius: 8px;\n  border-bottom-right-radius: 8px;\n  margin-bottom: 0;\n}\n\n.weather-alert .alert-header {\n  display: flex;\n  align-items: center;\n  padding: 12px 16px;\n  cursor: pointer;\n  position: relative;\n}\n\n.weather-alert:first-child .alert-header {\n  background-color: #c41e3a;\n  color: white;\n}\n\n.weather-alert:first-child .alert-headline {\n  color: white;\n  font-weight: 700;\n}\n\n.weather-alert .alert-icon {\n  margin-right: 12px;\n  font-size: 20px;\n  flex-shrink: 0;\n}\n\n.weather-alert .alert-headline {\n  flex-grow: 1;\n  font-size: 14px;\n  font-weight: 600;\n  color: #333;\n}\n\n.weather-alert .alert-toggle {\n  margin-left: 8px;\n  font-size: 12px;\n  color: inherit;\n  opacity: 0.7;\n}\n\n.weather-alert .alert-details {\n  padding: 0 16px 16px;\n  background-color: #f8f9fa;\n  font-size: 14px;\n  line-height: 1.5;\n  border-top: 1px solid #eee;\n}\n\n.weather-alert .alert-meta {\n  display: flex;\n  justify-content: space-between;\n  padding: 12px 0;\n  font-size: 13px;\n  color: #666;\n}\n\n.weather-alert .alert-instructions h4,\n.weather-alert .alert-description h4 {\n  margin: 0 0 8px;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.weather-alert .alert-instructions p,\n.weather-alert .alert-description p {\n  margin: 0 0 16px;\n  white-space: pre-line;\n}\n\n.weather-alert .alert-timing {\n  font-size: 12px;\n  color: #666;\n  padding-top: 12px;\n  border-top: 1px solid #eee;\n}\n\n.weather-alert .alert-timing p {\n  margin: 4px 0;\n}\n\n/* Animation for expanded alert */\n.weather-alert.expanded {\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n/* Winter storm watch specific styling to match screenshot */\n.weather-alert[data-alert-type=\"winter-storm-watch\"] .alert-header {\n  background-color: #c41e3a;\n  color: white;\n}\n\n/* Special styling for different severity levels */\n.weather-alert.extreme {\n  background-color: rgba(217, 43, 43, 0.05);\n}\n\n.weather-alert.severe {\n  background-color: rgba(255, 92, 51, 0.05);\n}\n\n.weather-alert.moderate {\n  background-color: rgba(255, 166, 77, 0.05);\n}\n\n/* Animation for the toggle */\n.alert-toggle {\n  transition: transform 0.3s ease;\n}\n\n.weather-alert.expanded .alert-toggle {\n  transform: rotate(180deg);\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .alert-meta {\n    flex-direction: column;\n  }\n  \n  .alert-severity {\n    margin-bottom: 4px;\n  }\n} "],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
